module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=FO - Faroe Islands.81d0f7cf.svg";